module.exports = __webpack_public_path__ + "static/media/banner-img3.05207d30.jpg";